import Notifications from "react-notification-system-redux";
import { connect } from "react-redux";
import UberDirectBatchModal from "./UberDirectBatchModal";
import {
  DISPATCH_MAIN_MODAL_HIDE,
  DISPATCH_DOCK_UBERDIRECT_BATCH,
  DISPATCH_DOCK_UBERDIRECT_BATCH_SENDING,
} from "../../actions/modal";

const mapStateToProps = state => ({
  modal: state.dispatch.modal,
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch({ type: DISPATCH_MAIN_MODAL_HIDE }),
  onCreateBatch: (dockId, dropoffReady, dropoffDeadline) => {
    dispatch({ type: DISPATCH_DOCK_UBERDIRECT_BATCH_SENDING, sending: true });
    return dispatch({
      type: DISPATCH_DOCK_UBERDIRECT_BATCH,
      dockId,
      dropoffReady,
      dropoffDeadline,
    });
  },
  notifyError: (errorMessage) => dispatch(
    Notifications.error({
      title: "UberDirect Batch",
      message: errorMessage,
      autoDismiss: 5,
      dismissible: "click"
    })
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(UberDirectBatchModal);
